import React from 'react';
import { FaExclamationTriangle, FaRedo, FaHome } from 'react-icons/fa';

const ErrorMessage = ({ message, onRetry, onRestart, showHome = false }) => {
    return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
            <div className="flex justify-center mb-4">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
                    <FaExclamationTriangle className="text-red-500 text-2xl" />
                </div>
            </div>

            <h3 className="text-lg font-semibold text-red-800 mb-2">
                Error en el Asistente de Marketing
            </h3>

            <p className="text-red-600 mb-6 max-w-md mx-auto">
                {message || 'Ha ocurrido un error inesperado durante el análisis. Por favor, inténtalo de nuevo.'}
            </p>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-yellow-800 text-sm">
                    <strong>💡 Consejo:</strong> Si el problema persiste, verifica tu conexión a internet
                    y que todos los datos de tu negocio estén actualizados.
                </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
                {onRetry && (
                    <button
                        onClick={onRetry}
                        className="flex items-center justify-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                    >
                        <FaRedo className="mr-2" />
                        Reintentar
                    </button>
                )}

                {onRestart && (
                    <button
                        onClick={onRestart}
                        className="flex items-center justify-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                    >
                        <FaHome className="mr-2" />
                        Empezar de Nuevo
                    </button>
                )}

                {showHome && (
                    <button
                        onClick={() => window.location.href = '/'}
                        className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        <FaHome className="mr-2" />
                        Ir al Inicio
                    </button>
                )}
            </div>
        </div>
    );
};

export default ErrorMessage; 